import React from 'react'
import CheckableListItem from './CheckableListItem'
import './CheckableList.css'

type CheckableListProps = {
  list: {
    checked: boolean
    id: GeneralId,
    label: string
  }[]
  onCheckItem: (id: GeneralId, label: string) => void
}

const CheckableList = ({
  list,
  onCheckItem,
}: CheckableListProps) => (
  <div className="selectable-list">
    {list.map((item) => (
      <CheckableListItem
        key={item.id.toString()}
        id={item.id}
        label={item.label}
        onCheckItem={onCheckItem}
        checked={item.checked}
      />
    ))}
  </div>
)

export default CheckableList
